import React from 'react';
import { Skeleton, YStack } from '@usepepper/sprout-kit-ui';
import { useTheme } from '@/contexts/theme-context';

const TITLE_HEIGHT = 20; // -4px to account for spacing

export const InsightCardHeaderSkeleton: React.FC = () => {
  const theme = useTheme();

  return (
    <YStack flex={1} gap="$8">
      <Skeleton
        borderRadius={theme.sk.radii.radiusRound}
        height={TITLE_HEIGHT}
        variant="rect"
        width="60%"
      />
      <Skeleton
        borderRadius={theme.sk.radii.radiusRound}
        height={14}
        variant="rect"
        width="45%"
      />
    </YStack>
  );
};
